import EmitEvent, {
    ANIMATION_TAB_CHANGE,
    OBSERVER_HEIGHT_CHANGED,
    PAGE_ENTER, PAGE_LEAVE,
    PAGE_LOADED,
    SMOOTH_SCROLLING
} from "./emit-event";
import {getScrollTop} from "./helper";

let servicesInstance = null;

class Services {

    offsetResponsive = {xl: 1600, lg: 1320, md: 1024, sm: 768};
    smooth_scrolling_instance;
    maxScrollHeight = 0;
    winSize;
    isResizeObserver;
    isSmoothScrolling = true;
    isPageEnter = false;
    DOM;
    scrollingType = 'contentLoaded';
    pageTransition = 'default';

    constructor() {
        if (servicesInstance) return servicesInstance;
        servicesInstance = this;
        this.smooth_scrolling_instance = 0;
        this.DOM = {main: document.querySelector('[data-scroll-container]')};
        this.isResizeObserver = !!window.ResizeObserver;
        this.handleResize();
        this.handleScrolling = this.handleScrolling.bind(this);
        this.bindEvent();
        this.emitEvent();

    }

    handleScrolling({instance}) {
        this.smooth_scrolling_instance = instance;
        if (this.scrollingType !== 'contentScrolling') this.scrollingType = 'contentScrolling';
    }

    handleWinScrolling() {
        this.scrollingType = 'contentScrolling';
        this.smooth_scrolling_instance = getScrollTop();
    }

    handleResize() {
        this.winSize = {width: window.innerWidth, height: window.innerHeight};
        this.winSize.aspectRatio = this.winSize.width / this.winSize.height;
    }

    bindEvent() {
        window.addEventListener('resize', this.handleResize.bind(this));
        if (this.isResizeObserver) {
            const resizeObserver = new ResizeObserver(() => EmitEvent.emit(OBSERVER_HEIGHT_CHANGED));
            resizeObserver.observe(this.DOM.main);
        }
    }

    emitEvent() {
        EmitEvent.on(SMOOTH_SCROLLING, this.handleScrolling);
        EmitEvent.on(PAGE_ENTER, () => {
            this.isPageEnter = true;

        });
        EmitEvent.on(ANIMATION_TAB_CHANGE, () => this.scrollingType = 'contentScrolling');
        EmitEvent.on(PAGE_LOADED, () => {
            this.scrollingType = 'contentLoaded';
        });

        EmitEvent.on(PAGE_LEAVE, () => {
            this.smooth_scrolling_instance = 0;
            this.isPageEnter = false;
        });
    }
}

export default new Services();